import React from 'react';
import Spinner from '../assets/images/spinner-primary.svg';

export default () => {
  return <img src={Spinner} alt="Primary Spinner" />;
};
